import { InfoOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, TextCaption, Tooltip } from '@carboncopyco/ui';
import { useRef } from 'react';

export const AutoSyncInfoIcon = () => {
  const infoIconRef = useRef<HTMLDivElement>(null);
  return (
    <div className="flex items-center gap-1">
      <TextCaption label="Auto-sync" />
      <div ref={infoIconRef}>
        <InfoOutlineIcon
          color={ColorHex.natural300}
          size={12}
        />
      </div>
      <Tooltip
        placement="top"
        anchorRef={infoIconRef}
        noArrow
      >
        <div className="p-3 w-48">
          <TextCaption
            color="text-ds-natural-400"
            label="Auto-sync will automatically sync any changes made to an asset and reflect them in the playbook."
          />
        </div>
      </Tooltip>
    </div>
  );
};
